import { createAction, props } from '@ngrx/store'
import { SiteAnnouncementsEntity } from './site-announcements.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'

export const loadSiteAnnouncements = createAction(
  '[Staff/API] Load Site Announcements',
  props<{ limit?: number; offset?: number }>(),
)

export const loadSiteAnnouncementsSuccess = createAction(
  '[Staff/API] Load Site Announcements success',
  props<{ site_announcements: SiteAnnouncementsEntity[] }>(),
)

export const loadSiteAnnouncementsFailure = createAction(
  '[Staff/API] Load Site Announcements Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateSiteAnnouncement = createAction(
  '[Staff/API] update Site Announcements',
  props<{ site_announcement: Partial<SiteAnnouncementsEntity> }>(),
)

export const updateSiteAnnouncementSuccess = createAction(
  '[Staff/API] update Site Announcements success',
  props<{ update: Update<SiteAnnouncementsEntity> }>(),
)

export const updateSiteAnnouncementFailure = createAction(
  '[Staff/API] update Site Announcements Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const createSiteAnnouncement = createAction(
  '[Staff/API] create Site Announcements',
  props<{ site_announcement: Partial<SiteAnnouncementsEntity> }>(),
)

export const createSiteAnnouncementSuccess = createAction(
  '[Staff/API] create Site Announcements success',
  props<{ site_announcement: SiteAnnouncementsEntity }>(),
)

export const createSiteAnnouncementFailure = createAction(
  '[Staff/API] create Site Announcements Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteSiteAnnouncement = createAction(
  '[Staff/API] delete Site Announcements',
  props<{ uuid: string; title: string }>(),
)

export const deleteSiteAnnouncementSuccess = createAction(
  '[Staff/API] delete Site Announcements success',
  props<{ uuid: string }>(),
)

export const deleteSiteAnnouncementFailure = createAction(
  '[Staff/API] delete Site Announcements Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectSiteAnnouncement = createAction(
  '[Staff/Page] Select a Site Announcements',
  props<{ uuid: string | undefined }>(),
)

export const openAnnouncementListDialog = createAction('[Staff/Page] Open Announcement List Dialog')

export const setUnreadAnnouncements = createAction(
  '[Staff/API] Update unread Announcements by reading the ReadStatusMap',
)
